module.exports = __webpack_public_path__ + "static/media/ottawa-42.6a100bdd.jpg";